export default "__VITE_ASSET__e93b3458__"